/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 24);
/******/ })
/************************************************************************/
/******/ ({

/***/ 24:
/***/ (function(module, exports) {

var eeElement = document.querySelector('.easterEgg');
var eePlaceholder = document.createElement('div');
var easterEggShadow = document.querySelector('#iconShadow');
var eeShadowPath = document.querySelector('#iconShadow path');
var eeIconWithBackground = document.querySelector('.iconWithBackground');
var eePosition = {
  x: 0,
  y: 0
};
var eeVerticalAcceleration = 1;
var eeIconClickCount = 0;
var eeStartEasterEgg = false;
var eeElementHeight = 0;
var eeElementWidth = 0;
var eeYVelocity = 0;
var eeXVelocity = 0;
var eeScale = 1;
var eeRotation = 0;

function eeOffset(el) {
  var rect = el.getBoundingClientRect();
  var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return {
    top: rect.top + scrollTop,
    left: rect.left + scrollLeft
  };
}

eeElement.addEventListener('click', function () {
  eeIconClickCount += 1;

  if (eeIconClickCount >= 10 && eeIconClickCount < 15) {
    var clickDirection = Math.random() < 0.5 ? -1 : 1;
    eeIconWithBackground.style.transform = "rotate(".concat((eeIconClickCount - 9) / 15 * 60 * clickDirection, "deg)");
    return;
  }

  if (eeIconClickCount > 15 && eeXVelocity < 1 && eeYVelocity < 1) {
    eeXVelocity += (Math.random() - 0.5) * 20;
    eeYVelocity -= 20;
    return;
  }

  if (eeIconClickCount === 15) {
    eeXVelocity = 10 * Math.random();
    eeYVelocity = 10 * Math.random();
    eeElementHeight = parseInt(window.getComputedStyle(eeElement.parentNode).getPropertyValue('height'), 10);
    eeElementWidth = parseInt(window.getComputedStyle(eeElement.parentNode).getPropertyValue('width'), 10);
    eePosition.x = -(eeElementWidth / 2);
    eePlaceholder.innerHTML = '[cool big icon]';
    eePlaceholder.style.height = "".concat(eeElementHeight, "px");
    eeElement.parentNode.insertBefore(eePlaceholder, eeElement);
    eeElement.style.top = "".concat(eePosition.y, "px");
    eeElement.style.left = "".concat(eePosition.x, "px");
    eeElement.style.position = 'absolute';
    eeElement.style.zIndex = 1;
    eeScale = eeElementWidth / 111;
    eeShadowPath.style.fill = '#aaa';
    eeStartEasterEgg = true;
  }
});

function step() {
  if (eeStartEasterEgg) {
    eeYVelocity += eeVerticalAcceleration;

    if (eeOffset(eeElement).left + eeXVelocity < 0) {
      eeXVelocity = -eeXVelocity;
      eePosition.x -= eeOffset(eeElement).left + eeXVelocity;
    } else if (eeOffset(eeElement).left + eeElementWidth + eeXVelocity > window.innerWidth) {
      eeXVelocity = -eeXVelocity;
      eePosition.x -= eeOffset(eeElement).left + eeElementWidth + eeXVelocity - window.innerWidth;
    }

    eePosition.x += eeXVelocity;

    if (eeOffset(eeElement).top + eeElementHeight + eeYVelocity > window.innerHeight) {
      eePosition.y -= eeOffset(eeElement).top + eeElementHeight + eeYVelocity - window.innerHeight;
      eePosition.y += eeYVelocity;
      eeElement.style.top = "".concat(eePosition.y, "px");
      eeYVelocity *= -0.5;
      eeXVelocity *= 0.95;

      if (Math.abs(eeYVelocity) < 0.1 && Math.abs(eeXVelocity) < 0.1) {
        return;
      }
    } else {
      eePosition.y += eeYVelocity;
    }

    eeElement.style.top = "".concat(eePosition.y, "px");
    eeElement.style.left = "".concat(eePosition.x, "px");
    eeRotation += eeXVelocity;
    eeIconWithBackground.style.transform = "rotate(".concat(eeRotation, "deg)");
    var distanceFromBottom = (window.innerHeight - eeOffset(eeElement).top) / eeScale;
    eeElement.style.height = "".concat(distanceFromBottom, "px");
    var shadowSize = distanceFromBottom - eeElementHeight - 300;
    shadowSize = shadowSize < 0 ? Math.max(0.2, Math.abs(shadowSize) / 300) : 0.2;
    easterEggShadow.style.transform = "translate(10px, ".concat(distanceFromBottom - 29, "px) scale(").concat(shadowSize, ")");
  }

  window.requestAnimationFrame(step);
}

window.requestAnimationFrame(step);

/***/ })

/******/ });


// WEBPACK FOOTER //
// js/signin/eeSage2019.js